import { GetImageUrl } from "../helpers/GetImageUrl";

export const SITE_URL = "https://www.suraksha24x7.com";
export const DEFAULT_SOCIAL_IMAGE = `${SITE_URL}/Suraksha24x7logo.png`;

export const getProductCanonicalUrl = (product) => {
  const productSlug = product?.slug || product?._id;
  const catalogPath =
    product?.catalogType === "ip-network" ||
    product?.ipNetworkCategory ||
    product?.ipNetworkSubCategory
      ? "it-products"
      : "security-product";
  return productSlug
    ? `${SITE_URL}/${catalogPath}/${encodeURIComponent(productSlug)}`
    : "";
};

export const getProductOgImage = (product) => {
  const image =
    product?.ogImage?.url ||
    (typeof product?.ogImage === "string" ? product.ogImage : "") ||
    product?.images?.find((item) => item?.url)?.url ||
    product?.images?.find((item) => typeof item === "string");

  return image ? GetImageUrl(image) : DEFAULT_SOCIAL_IMAGE;
};

export const buildProductWhatsAppMessage = ({
  product,
  enquiryType = "Product Enquiry",
}) => {
  const productName = product?.title || product?.assetId || "Security Product";
  const brandName =
    product?.brand?.brandName || product?.ipNetworkBrand?.brandName;
  const categoryName =
    product?.category?.name || product?.ipNetworkCategory?.name;
  const subCategoryName =
    product?.subCategory?.name || product?.ipNetworkSubCategory?.name;
  const productUrl = getProductCanonicalUrl(product);
  const details = [
    `📦 ${productName}`,
    product?.assetId && product.assetId !== productName
      ? `🔖 Model: ${product.assetId}`
      : "",
    brandName ? `🏷️ Brand: ${brandName}` : "",
    categoryName ? `📁 Category: ${categoryName}` : "",
    subCategoryName ? `📂 Sub Category: ${subCategoryName}` : "",
  ].filter(Boolean);

  return `Hello Suraksha 24X7 👋

I would like to enquire about the following product:

${details.join("\n")}

🔗 Product Details:
${productUrl}

Enquiry type: ${enquiryType}

Please share:
✅ Current price
✅ Product availability
✅ Installation information
✅ Warranty & support

Please assist me.

Thank you.`;
};
